import { RGBAColor } from 'src/common-services'
import { Colors } from 'src/components/theme'
import { rgbaStrToArray } from 'src/utils/colors'

const BLUE = rgbaStrToArray(Colors.blueMedium, 1 * 255)
const BLUE_DARK = rgbaStrToArray(Colors.blueMedium, 0.8 * 255)
const BLUE_MEDIUM = rgbaStrToArray(Colors.blueMedium, 0.6 * 255)
const BLUE_LIGHT = rgbaStrToArray(Colors.blueMedium, 0.4 * 255)
const BLUE_EXTRA_LIGHT = rgbaStrToArray(Colors.blueMedium, 0.2 * 255)

const BLUES = [
  {
    color: BLUE,
    fillColor: BLUE_EXTRA_LIGHT,
    lineColor: BLUE,
  },
  {
    color: BLUE,
    fillColor: BLUE_LIGHT,
    lineColor: BLUE,
  },
  {
    color: BLUE,
    fillColor: BLUE_MEDIUM,
    lineColor: BLUE,
  },
  {
    color: BLUE,
    fillColor: BLUE_DARK,
    lineColor: BLUE,
  },
]

const GREEN = rgbaStrToArray(Colors.bgGreenDark, 1 * 255)
const GREEN_DARK = rgbaStrToArray(Colors.bgGreenDark, 0.8 * 255)
const GREEN_MEDIUM = rgbaStrToArray(Colors.bgGreenDark, 0.6 * 255)
const GREEN_LIGHT = rgbaStrToArray(Colors.bgGreenDark, 0.4 * 355)
const GREEN_EXTRA_LIGHT = rgbaStrToArray(Colors.bgGreenDark, 0.2 * 255)

const GREENS = [
  {
    color: GREEN,
    fillColor: GREEN_EXTRA_LIGHT,
    lineColor: GREEN,
  },
  {
    color: GREEN,
    fillColor: GREEN_LIGHT,
    lineColor: GREEN,
  },
  {
    color: GREEN,
    fillColor: GREEN_MEDIUM,
    lineColor: GREEN,
  },
  {
    color: GREEN,
    fillColor: GREEN_DARK,
    lineColor: GREEN,
  },
]

const RED = rgbaStrToArray(Colors.redDark, 1 * 255)
const RED_DARK = rgbaStrToArray(Colors.redDark, 0.8 * 255)
const RED_MEDIUM = rgbaStrToArray(Colors.redDark, 0.6 * 255)
const RED_LIGHT = rgbaStrToArray(Colors.redDark, 0.4 * 255)
const RED_EXTRA_LIGHT = rgbaStrToArray(Colors.redDark, 0.2 * 255)

const REDS = [
  {
    color: RED,
    fillColor: RED_DARK,
    lineColor: RED,
  },
  {
    color: RED,
    fillColor: RED_MEDIUM,
    lineColor: RED,
  },
  {
    color: RED,
    fillColor: RED_LIGHT,
    lineColor: RED,
  },
  {
    color: RED,
    fillColor: RED_EXTRA_LIGHT,
    lineColor: RED,
  },
]

export const MIXED = [
  {
    color: rgbaStrToArray('rgba(248, 45, 97, 1)'),
    fillColor: rgbaStrToArray('rgba(248, 45, 97, 1)'),
    lineColor: rgbaStrToArray('rgba(248, 45, 97, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(243, 78, 79, 1)'),
    fillColor: rgbaStrToArray('rgba(243, 78, 79, 1)'),
    lineColor: rgbaStrToArray('rgba(243, 78, 79, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(240, 97, 68, 1)'),
    fillColor: rgbaStrToArray('rgba(240, 97, 68, 1)'),
    lineColor: rgbaStrToArray('rgba(240, 97, 68, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(237, 117, 56, 1)'),
    fillColor: rgbaStrToArray('rgba(237, 117, 56, 1)'),
    lineColor: rgbaStrToArray('rgba(237, 117, 56, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(233, 140, 44, 1)'),
    fillColor: rgbaStrToArray('rgba(233, 140, 44, 1)'),
    lineColor: rgbaStrToArray('rgba(233, 140, 44, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(214, 156, 46, 1)'),
    fillColor: rgbaStrToArray('rgba(214, 156, 46, 1)'),
    lineColor: rgbaStrToArray('rgba(214, 156, 46, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(170, 167, 69, 1)'),
    fillColor: rgbaStrToArray('rgba(170, 167, 69, 1)'),
    lineColor: rgbaStrToArray('rgba(170, 167, 69, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(127, 177, 92, 1)'),
    fillColor: rgbaStrToArray('rgba(127, 177, 92, 1)'),
    lineColor: rgbaStrToArray('rgba(127, 177, 92, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(83, 189, 116, 1)'),
    fillColor: rgbaStrToArray('rgba(83, 189, 116, 1)'),
    lineColor: rgbaStrToArray('rgba(83, 189, 116, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(21, 204, 148, 1)'),
    fillColor: rgbaStrToArray('rgba(21, 204, 148, 1)'),
    lineColor: rgbaStrToArray('rgba(21, 204, 148, 1)'),
  },
]
const DEFAULTS = [MIXED[9], MIXED[4], MIXED[0]]

// +30% - +100% | +30% - -30% | -30% - -100%
const COMPARE = [
  {
    color: rgbaStrToArray('rgba(115, 103, 255, 0.9)'),
    fillColor: rgbaStrToArray('rgba(115, 103, 255, 0.9)'),
    lineColor: rgbaStrToArray('rgba(63, 82, 95, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(115, 103, 255, 0.7)'),
    fillColor: rgbaStrToArray('rgba(115, 103, 255, 0.7)'),
    lineColor: rgbaStrToArray('rgba(63, 82, 95, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(115, 103, 255, 0.5)'),
    fillColor: rgbaStrToArray('rgba(115, 103, 255, 0.5)'),
    lineColor: rgbaStrToArray('rgba(63, 82, 95, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(115, 103, 255, 0.3)'),
    fillColor: rgbaStrToArray('rgba(115, 103, 255, 0.3)'),
    lineColor: rgbaStrToArray('rgba(63, 82, 95, 1)'),
  },
  {
    color: rgbaStrToArray('rgba(115, 103, 255, 0.1)'),
    fillColor: rgbaStrToArray('rgba(115, 103, 255, 0.1)'),
    lineColor: rgbaStrToArray('rgba(63, 82, 95, 1)'),
  },
]

export type ColorByIndexType = 'blue' | 'green' | 'red' | 'mixed' | 'default' | 'compare'
export const getMapColorsByIndex = (
  colorIndex: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9,
  color: ColorByIndexType
): { color: RGBAColor; fillColor: RGBAColor; lineColor: RGBAColor } => {
  switch (color) {
    case 'default':
      return DEFAULTS[colorIndex]
    case 'blue':
      return BLUES[colorIndex]
    case 'green':
      return GREENS[colorIndex]
    case 'red':
      return REDS[colorIndex]
    case 'mixed':
      return MIXED[colorIndex]
    case 'compare':
      return COMPARE[colorIndex]
    default:
      return DEFAULTS[colorIndex]
  }
}
